module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan2-3-7d8d6089cf5220e3709d4e23d7e9f544.webp";